<template>
  <div class="screen screen__contact" v-loading="!page.title">
    <page-banner :heading="page.title" :sub-heading="page.subheading" />
    <el-container direction="vertical" class="page--container">
      <el-row>
        <el-col :md="{ span: 16, offset: 4 }">
          <section class="page--section">
            <el-alert v-if="errorCode" type="error" show-icon :closable="false" :title="$t(errorCode)" />
            <div class="callout" v-html="page.callout" />
          </section>
        </el-col>
      </el-row>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import singles from '@/components/singles';
import PageBanner from '@/components/PageBanner.vue';
const PAGE_KEY = 'error';

export default {
  name: 'ErrorPage',
  data() {
    return {
      page: {}
    };
  },
  props: {
    'errorCode': String,
  },
  components: {
    PageBanner
  },
  methods: {
    ...mapActions(singles.store.namespace, ['getPage']),
  },
  beforeMount() { this.getPage(PAGE_KEY).then(page => this.page = page) },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.screen__contact {
  .el-row {
    background-color: $--color-white;
  }
}
</style>

